var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading)?_c('Match',{attrs:{"match-id":_vm.matchId,"round":_vm.matchRound,"match-data":_vm.matchData},on:{"update":_vm.handleMatchUpdate}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }